import * as React from "react";
import { Button, Dropdown } from "antd";
import { useNavigate } from "react-router-dom";
import { ItemType, MenuItemType } from "antd/es/menu/interface";
import { DownOutlined } from "@ant-design/icons";
import { useAppSelector } from "../../../../store/hooks";
import { selectOrg } from "../../../../store/contextSlice";
import { selectHasAccount } from "../../../../store/userDataSlice";

export const GenericCreate: React.FC = () => {
  const navigate = useNavigate();
  const org = useAppSelector(selectOrg);
  const dashboard = useAppSelector((state) => state.uiData.dashboard);
  const hasAccount = useAppSelector(selectHasAccount);

  function handleMenuClick(e: any) {
    switch (true) {
      case e.key === "template":
        navigate(`/console/org/${org}/marketplace?redirect=template`);
        break;
      case e.key === "agent":
        navigate(`/console/org/${org}/agent/-create`);
        break;
      case e.key === "auditctx":
        navigate(`/console/org/${org}/auditctx/-create`);
        break;
      case e.key === "cloudaccount":
        navigate(`/console/org/${org}/cloudaccount/-create`);
        break;
      case e.key === "domain":
        navigate(`/console/org/${org}/domain/-draft`);
        break;
      case e.key === "group":
        navigate(`/console/org/${org}/group/-create`);
        break;
      case e.key === "gvc":
        navigate(`/console/org/${org}/gvc/-create`);
        break;
      case e.key === "identity":
        navigate(`/console/org/${org}/identity/-create`);
        break;
      case e.key === "ipset":
        navigate(`/console/org/${org}/ipset/-create`);
        break;
      case e.key === "mk8s":
        navigate(`/console/org/${org}/mk8s/-create`);
        break;
      case e.key === "location":
        navigate(`/console/org/${org}/location/-create`);
        break;
      case e.key === "org":
        navigate(`/home/org/-create`);
        break;
      case e.key === "policy":
        navigate(`/console/org/${org}/policy/-create`);
        break;
      case e.key === "secret":
        navigate(`/console/org/${org}/secret/-create`);
        break;
      case e.key === "serviceaccount":
        navigate(`/console/org/${org}/serviceaccount/-create`);
        break;
      case e.key === "volumeset":
        navigate(`/console/org/${org}/volumeset/-create`);
        break;
      case e.key === "workload":
        navigate(`/console/org/${org}/workload/-create`);
        break;
      default:
        break;
    }
  }

  if (dashboard !== "console") {
    return null;
  }

  const items: ItemType<MenuItemType>[] = [];
  items.push(
    //
    { key: "template", label: "Template" },
    { type: "divider" },
    { key: "agent", label: "Agent" },
    { key: "auditctx", label: "Audit Context" },
    { key: "cloudaccount", label: "Cloud Account" },
    { key: "domain", label: "Domain" },
    { key: "group", label: "Group" },
    { key: "gvc", label: "GVC" },
    // gvc scoped
    { key: "identity", label: "Identity" },
    //
    { key: "ipset", label: "IP Set" },
    { key: "mk8s", label: "Kubernetes" },
    { key: "location", label: "Location" },
  );
  if (hasAccount) {
    items.push({ key: "org", label: "Org" });
  }
  items.push(
    { key: "policy", label: "Policy" },
    { key: "secret", label: "Secret" },
    { key: "serviceaccount", label: "Service Account" },
    // gvc scoped
    { key: "volumeset", label: "Volume Set" },
    { key: "workload", label: "Workload" },
  );

  return (
    <Dropdown
      trigger={["click"]}
      menu={{ onClick: handleMenuClick, className: "menu", items: items }}
      getPopupContainer={() => document.getElementById("genericCreate") as any}
    >
      <Button data-testid="generic-create" type="primary" className="action" icon={<DownOutlined />} iconPosition="end">
        Create
      </Button>
    </Dropdown>
  );
};
